import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core';

import styles from './styles';

const ProgressBar = ({ count, limit }) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  return (
    <div className={classes.progressBarContainer}>
      <div className={classes.progressBar}>
        <div
          className={classes.progressBarProgress}
          style={{ width: `${count > limit ? (limit / count) * 100 : (count / limit) * 100}%` }}
        />
        <div
          className={classes.progressBarErrorProgress}
          style={{ width: `${count > limit ? ((count - limit) / count) * 100 : 0}%` }}
        />
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  count: PropTypes.number,
  limit: PropTypes.number,
}

export default ProgressBar;